import angular from 'angular';
// {"url":"url_completa","key":"campo"(optional),"text":"campo"(optional),"headers":{},"multiple":false}

/**
 * Controla la tabla de inspecciones.
 */
CamposExtraListApiCtrl.$inject = ['$http', 'dialogService', '$filter'];

export default function CamposExtraListApiCtrl($http, dialogService, $filter) {

    var campExtListApi = this;

    campExtListApi.claseRow = issetAndNotEmpty(campExtListApi.claseRow) ? campExtListApi.claseRow == 'true' : true;
    var teniaValor = campExtListApi.campoExtra.valor !== null && campExtListApi.campoExtra.valor.length > 0;

    var DIALOG_AUTOCOMPLETE_TEMPLATE = require('./dialog-autocomplete/dialog-autocomplete.html');

    campExtListApi.jsonOptions = angular.fromJson(campExtListApi.campoExtra.json);

    campExtListApi.hasError = false;
    campExtListApi.updateError = false;
    campExtListApi.loading = false;

    campExtListApi.options = [];
    campExtListApi.optionSelected = null;

    if (campExtListApi.campoExtra.valor != null)
        campExtListApi.optionSelected = JSON.parse(campExtListApi.campoExtra.valor_json);

    campExtListApi.edit = function () {
        var titulo = campExtListApi.campoExtra.nombre;
        var options = {title: titulo};
        var datos = {
            campoExtra: campExtListApi.jsonOptions,
            campoExtraValor: campExtListApi.campoExtra.valor,
            optionSelected: campExtListApi.optionSelected,
            id_model: campExtListApi.modelId
        };

        var opcionesExtra = {deshabilitarBotones: true};

        dialogService.open("dialog-auto-complete", DIALOG_AUTOCOMPLETE_TEMPLATE, datos, options, opcionesExtra).then(
            function (res) {
                var selected = res;

                if (typeof campExtListApi.jsonOptions.multiple !== "undefined" && campExtListApi.jsonOptions.multiple) {
                    campExtListApi.campoExtra.valor = res.map(val => campExtListApi.valueOption(val)).join(",");
                    campExtListApi.campoExtra.valor_descripcion = res.map(val => campExtListApi.textOption(val)).join(",");
                    campExtListApi.campoExtra.valor_json = "[" + res.map(val => JSON.stringify(val)).join(",") + "]";

                    campExtListApi.optionSelected = selected;
                    campExtListApi.validate();
                } else {
                    campExtListApi.campoExtra.valor = campExtListApi.valueOption(selected);
                    campExtListApi.campoExtra.valor_descripcion = campExtListApi.textOption(selected);
                    campExtListApi.campoExtra.valor_json = JSON.stringify(selected);

                    campExtListApi.optionSelected = selected;
                    campExtListApi.validate();
                }
            }
        );
    };

    campExtListApi.validate = function () {
        if (issetAndNotEmpty(campExtListApi.campoExtra.valor)) {
            campExtListApi.hasError = false;
            campExtListApi.campoExtra.changed = true;
        } else if (teniaValor) {
            campExtListApi.hasError = true;
            campExtListApi.campoExtra.changed = false;
        }
    };

    campExtListApi.borrar = function () {
        campExtListApi.campoExtra.valor = null;
        campExtListApi.campoExtra.valor_descripcion = null;
        campExtListApi.campoExtra.valor_json = null;
        campExtListApi.campoExtra.changed = true;
        campExtListApi.optionSelected = null;
    };

    campExtListApi.valueOption = function (option) {
        return option[campExtListApi.jsonOptions.key];
    };

    campExtListApi.textOption = function (option) {
        return option[campExtListApi.jsonOptions.text] + " " + option[campExtListApi.jsonOptions.descrip];
    };

    campExtListApi.printCurrentValue = function () {
        if (campExtListApi.optionSelected == null)
            return $filter('capitalize')($filter('lang')('nombres.sin_valor', 'get'));

        if (typeof campExtListApi.jsonOptions.multiple !== "undefined" && campExtListApi.jsonOptions.multiple) {
            let txt = [];
            campExtListApi.optionSelected.forEach(val => txt.push(campExtListApi.textOption(val)));
            txt = txt.join(", ")

            if (txt.length <= 40) return txt;
            return `${txt.substring(0, 40)}... (${campExtListApi.optionSelected.length} ${Lang.choice('nombres.seleccionado', 2)})`;
        }

        return campExtListApi.textOption(campExtListApi.optionSelected);
    };
}